import React from 'react';
import { Link } from 'react-router-dom';
import * as Dialog from '@radix-ui/react-dialog';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { MobileNavItem } from './MobileNavItem';
import { navigationGroups } from '../../config/navigationGroups';

export function MobileNavigation() {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          aria-label="Open menu"
        >
          <Menu className="h-5 w-5" />
        </Button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" />
        <Dialog.Content className="fixed inset-x-0 top-0 h-screen bg-gray-900/95 p-6 shadow-lg animate-in slide-in-from-top z-50">
          <div className="flex items-center justify-between mb-8">
            <Link to="/" className="text-xl font-bold text-white">
              Speaker Fix
            </Link>
            <Dialog.Close asChild>
              <Button variant="ghost" size="icon" aria-label="Close menu">
                <X className="h-5 w-5" />
              </Button>
            </Dialog.Close>
          </div>
          <Dialog.Title className="sr-only">Navigation Menu</Dialog.Title>
          <nav className="space-y-6 overflow-y-auto max-h-[calc(100vh-8rem)]">
            {navigationGroups.map((group) => (
              <div key={group.label} className="space-y-3">
                <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider px-3">
                  {group.label}
                </div>
                <div className="space-y-1">
                  {group.items.map((item) => (
                    <MobileNavItem key={item.href} item={item} />
                  ))}
                </div>
              </div>
            ))}
            <div className="pt-6 border-t border-white/10">
              <Link
                to="/blog"
                className="block px-3 py-2 text-base text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className="block px-3 py-2 text-base text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </nav>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}